import { CheckboxInput } from '@framework/form';
import React from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { ParagraphSizeText } from '../../common/style/ParagraphSizeText';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ComputedWidget } from '../IComputedWidget';

export interface IComputedBooleanWidgetPreviewProps
  extends IWidgetComponentProps<ComputedWidget> {}

export function ComputedBooleanWidgetPreview(
  props: IComputedBooleanWidgetPreviewProps,
) {
  const { componentLayout } = props;
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name="string"
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options?.helpText} />}
      layout={{ hideVisualLabel: options?.hideLabel }}
      readonly={options.readonly}
    >
      <CheckboxInput name="string">
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={options.text} />
        </ParagraphSizeText>
      </CheckboxInput>
    </ConfigFormItem>
  );
}
